import { createClient } from '@supabase/supabase-js';

// Supabase configuration - publishable key is safe to expose (RLS protects data)
const supabaseUrl = 'https://fqlgzaymblosubgkkeos.supabase.co';
const supabaseAnonKey = 'sb_publishable_aUbBVmUh1mTWTyDXN67veA_ZUqk4mVE';

// Use anon key - RLS policies will control data access
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Database types
export interface Estimation {
  id?: string;
  name: string;
  client_name: string;
  project_type: string;
  status: string;
  blueprint_url?: string;
  blueprint_name?: string;
  blueprint_size?: number;
  blueprint_path?: string;
  takeoff_scope?: 'full' | 'power_only';
  setup_gate_status?: 'ready' | 'missing_lighting_schedule';
  user_id?: string;
  created_at?: string;
  updated_at?: string;
}
